import { render, staticRenderFns } from "./CancelAccount.vue?vue&type=template&id=cf5aca6a&"
import script from "./CancelAccount.vue?vue&type=script&lang=js&"
export * from "./CancelAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports